import Application from "../Application";
import Area, { IArea } from "./Area";
import { IRouter } from "../runtime/Router";
import DeviceManagementPage from "../ui/pages/device/DeviceManagementPage";
import ShowDevicesInteractor from "../interactor/device/ShowDevicesInteractor";
import { IDevice } from "../model/device/Device";

export default class DeviceArea extends Area implements IArea {
  private application: Application;
  private router: IRouter;

  constructor({
    application,
    router
  }: {
    application: Application;
    router: IRouter;
  }) {
    super();
    this.application = application;
    this.router = router;
  }

  register(params: any) {
    this.router.registerRoutes({
      path: "/device-management",
      page: this.createPage({
        Page: DeviceManagementPage,
        action: this.showDevicePage.bind(this)
      }),
      options: {
        secure: true
      }
    });
  }

  public showDevicePage({ devices }: { devices: string }) {
    const _devices = JSON.parse(devices) as IDevice[];
    return this.application.container
      .resolve<ShowDevicesInteractor>("showDevices")
      .execute(_devices);
  }
}
